import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { ProcessoFinanceiroShell } from '../components/financeiro/ProcessoFinanceiroShell';

export const Route = createFileRoute(
  '/w/$workspaceId/clients/$clientId/processes/$processId/financeiro',
)({
  component: ProcessoFinanceiroTab,
});

function ProcessoFinanceiroTab() {
  const { workspaceId, clientId, processId } = Route.useParams();

  const { data: process } = useQuery({
    queryKey: ['processes', workspaceId, clientId, processId],
    queryFn: async () => {
      const res = await api.get(`/clients/${clientId}/processes/${processId}`);
      return res.data.data;
    },
  });

  const { data: client } = useQuery({
    queryKey: ['clients', workspaceId, clientId],
    queryFn: async () => {
      const res = await api.get(`/clients/${clientId}`);
      return res.data.data;
    },
  });

  return (
    <ProcessoFinanceiroShell
      workspaceId={workspaceId}
      processoId={processId}
      processoNumero={process?.processNumber ?? process?.cnjNumber ?? null}
      clienteId={clientId}
      clienteNome={client?.name ?? null}
    />
  );
}
